var map = {
	"./404bgr.png": 6923,
	"./Siegel-DAI.gif": 9135,
	"./arachnelogo.png": 9693,
	"./categories/Buchseiten.jpg": 7730,
	"./categories/Buchseiten_sw.jpg": 8484,
	"./categories/Inschriften.jpg": 7455,
	"./categories/Reproduktionen.jpg": 9416,
	"./categories/bauwerke.jpg": 3390,
	"./categories/bauwerke_sw.jpg": 3025,
	"./categories/bauwerksteile.jpg": 1116,
	"./categories/bilder.jpg": 9562,
	"./categories/buecher_sw.jpg": 4010,
	"./categories/einzelmotive.jpg": 5832,
	"./categories/mehrteiligdenk.jpg": 1884,
	"./categories/objekte.jpg": 1885,
	"./categories/objekte_sw.jpg": 61,
	"./categories/rezeptionen.jpg": 2787,
	"./categories/rezeptionen_sw.jpg": 2359,
	"./categories/sammlungen.jpg": 4756,
	"./categories/sammlungen_sw.jpg": 5913,
	"./categories/szene.jpg": 8590,
	"./categories/topographie.jpg": 8600,
	"./categories/topographie_sw.jpg": 3775,
	"./categories/typen_sw.jpg": 3110,
	"./categories/typus.jpg": 4290,
	"./categories/typus_sw.jpg": 257,
	"./edit_catalog_help/page_0.gif": 6335,
	"./edit_catalog_help/page_1.gif": 1071,
	"./edit_catalog_help/page_2.gif": 9288,
	"./edit_catalog_help/page_3.gif": 8596,
	"./edit_catalog_help/page_4.gif": 9030,
	"./edit_catalog_help/page_5.gif": 2079,
	"./edit_catalog_help/page_6.gif": 8575,
	"./edit_catalog_help/page_7.gif": 3717,
	"./edit_catalog_help/page_8.gif": 6831,
	"./frontpage/categories/bauwerksteile.webp": 6208,
	"./frontpage/categories/bilder.webp": 3511,
	"./frontpage/categories/buecher.webp": 1736,
	"./frontpage/categories/categories.webp": 7569,
	"./frontpage/categories/einzelobjekte.webp": 8679,
	"./frontpage/categories/mehrteilige-denkmaeler.webp": 1775,
	"./frontpage/categories/szenen.webp": 8936,
	"./frontpage/categories/topographien.webp": 6914,
	"./frontpage/categories/typen.webp": 6330,
	"./frontpage/home-bgr.webp": 7476,
	"./greif.png": 8332,
	"./imagePlaceholder.png": 7909,
	"./kleinergreif.png": 5931,
	"./language-icon.png": 4221,
	"./layers-2x.png": 8228,
	"./layers.png": 9827,
	"./logo_dai.png": 9630,
	"./logo_idai.png": 1262,
	"./logo_objects.png": 7896,
	"./logo_project.png": 4142,
	"./logo_unikoeln.png": 5921,
	"./marker-icon-2x.png": 6996,
	"./marker-icon.png": 6551,
	"./marker-shadow.png": 4537,
	"./placeholder/placeholder3D.png": 2529,
	"./placeholder/placeholderError.png": 2907,
	"./placeholder/placeholderFolder.png": 8417,
	"./placeholder/placeholderGruppierung.png": 4191,
	"./placeholder/placeholderLiteratur.png": 2795,
	"./placeholder/placeholderNoEntity.png": 2448,
	"./placeholder/placeholderNoImage.png": 9606,
	"./placeholder/placeholderOrt.png": 9971,
	"./placeholder/placeholderPerson.png": 8387,
	"./siegel_unikoeln.gif": 4092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4447;